import Disable2FaForm from './Disable2FaForm';

export default Disable2FaForm;
